export function ErrorPage() {
	return (
		<div className="flex justify-center items-center h-svh flex-col">
			<h1 className="font-bold text-3xl pb-4">Error.</h1>
			<a className="underline" href="/">
				Go back home
			</a>
		</div>
	);
}
